import loadable from '@loadable/component';

export default loadable(
    () => import(/* webpackChunkName: "BVUserGeneratedContentLazy" */ './BVUserGeneratedContent'),
    {
        fallback: null,
    }
);
